import { render, staticRenderFns } from "./RedirectionForm.vue?vue&type=template&id=1e04fd2f"
import script from "./RedirectionForm.vue?vue&type=script&lang=js"
export * from "./RedirectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports